
import React, { Component }  from 'react';
import { FormProvider, FormContext } from 'core/FormProvider';
import { UserContext } from 'components/User';
import Layout from 'components/Dashboard/Layout';
import { YellowButton} from 'ui/Button';
import { TariffBaseForm } from './FormBase';
import { PreloadTariff } from './PreloadTariff';


export default class TariffAdd extends Component {

  static contextType = UserContext;

  onDetail = (item) => {
    this.props.history.push(`/tariff`);
  };

  render() {
    const { match } = this.props;
    return (
      <FormProvider
        url={'tariff'}
        postSave={(item) => this.onDetail(item)}
        item={{
          department: this.context.data.department_active,
          resourcetype: 'TariffBase',
          is_active: true,
          tariff_points: [],
          services: []
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <PreloadTariff id={match.params.id} onUpdate={context.setValues}>
              <Layout>
                <Layout.Header
                  title={'Создание базового тарифа'}
                  backUrl={'/tariff'}
                />

                <Layout.ContentSimple>

                  <TariffBaseForm formContext={context} />

                  <div className={'mt-30'}>
                    <YellowButton
                      onClick={(e) => context.handleSubmit(e)}
                      size={'large'}
                      disabled={loading}
                    >
                      Создать базовый тариф
                    </YellowButton>
                  </div>
                </Layout.ContentSimple>

              </Layout>
            </PreloadTariff>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
